<script setup lang="ts">
import {Link, usePage} from '@inertiajs/vue3';
import {computed} from 'vue';

defineProps({
  currentLabel: {
    type: String,
    default: 'Current page',
  },
});

const breadcrumbs = computed(() => {
  return usePage().props.route.crumbs;
});
</script>
<template>
    <div
        v-if="breadcrumbs.length"
        class="outer-container my-4 flex w-full items-center gap-2 text-xs lg:my-8 lg:text-sm"
    >
        <template
            v-for="(breadcrumb, i) in breadcrumbs"
            :key="i"
        >
            <Link
                :href="breadcrumb.url"
                class="hover:underline"
            >
                {{ breadcrumb.label }}
            </Link>
            <span> > </span>
        </template>
        <span>{{ currentLabel }}</span>
    </div>
</template>
